export const SECTION_FIELDS = [
    'nationality',
    'docNumber',
    'name',
    'lastName',
    'birthDay',
    'birthMonth',
    'birthYear',
    'resident',
];
